import React, { useEffect, useState } from "react";

import { supabase } from "../../supabaseClient";
import HomeLive from "./HomeLive";
import HomeResults from "./HomeResults";
import HomeRaspored from "./HomeRaspored";
import HomeSponsors from "./HomeSponsors";
import HomeGroups from "./HomeGroups";
import BottomNavigation from "../Navigation/BottomNavigation";
import Navigation from "../Navigation/Navigation";
import HomeFooter from "./HomeFooter";
// import HomeNews from "./HomeNews";

const HomePage = ({ content }) => {
  const [activeTab, setActiveTab] = useState("live");
  const [teamsForSearch, setTeamsForSearch] = useState([]);
  const [playersForSearch, setPlayersForSearch] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [allMatches, setAllMatches] = useState([]);

  useEffect(() => {
    const fetchSearchData = async () => {
      // 1. Dohvat timova s igračima
      const { data: teams } = await supabase
        .from("teams")
        .select("name, group_name, players");
      if (teams) setTeamsForSearch(teams);

      // 2. Dohvat utakmica za računanje strijelaca
      const { data: matches } = await supabase.from("matches").select(`
    *,
    team_a:team_a_id(name),
    team_b:team_b_id(name)
  `);

      if (matches) {
        setAllMatches(matches);
        const scorerMap = {};

        matches.forEach((match) => {
          if (match.events && Array.isArray(match.events)) {
            match.events.forEach((event) => {
              if (event.type === "goal" || event.type === "penalty") {
                const pName = event.player;
                if (!pName) return;

                if (!scorerMap[pName]) {
                  scorerMap[pName] = { name: pName, goals: 0 };
                }
                scorerMap[pName].goals += 1;
              }
            });
          }
        });

        // Pretvaramo u niz koji Navigation može koristiti
        setPlayersForSearch(Object.values(scorerMap));
      }
    };
    fetchSearchData();
  }, []);

  // --- DODANI DIO: LOGIKA ZA PREPOZNAVANJE LINKA IZ INSTA STORYJA ---
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const tabParam = queryParams.get("tab");
    const highlight = queryParams.get("highlight");

    if (tabParam) {
      // Provjeravamo i engleske i hrvatske nazive
      if (tabParam === "results" || tabParam === "rezultati")
        setActiveTab("results");
      else if (tabParam === "schedule" || tabParam === "raspored")
        setActiveTab("schedule");
      else if (tabParam === "groups" || tabParam === "grupe")
        setActiveTab("groups");
    }

    // Logika za automatsko skrolanje
    if (highlight) {
      setTimeout(() => {
        const element = document.getElementById(
          `match-${decodeURIComponent(highlight)}`,
        );
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          element.classList.add("highlight-flash"); // Opcionalno: dodaj CSS za animaciju bljeska
        }
      }, 800); // 800ms je taman da se sadržaj učita
    }
  }, []);

  const renderHomeContent = () => {
    switch (activeTab) {
      case "live":
        return <HomeLive />;
      case "results":
        return <HomeResults />;
      case "schedule":
        return <HomeRaspored />;
      case "groups":
        return <HomeGroups activeGroupFromSearch={selectedGroup} />;
      default:
        return <HomeLive />;
    }
  };

  return (
    <>
      <Navigation
        setActiveTab={setActiveTab}
        setSelectedGroup={setSelectedGroup}
        teams={teamsForSearch}
        players={playersForSearch}
        matches={allMatches}
      />

      <main className="home-page" style={{ paddingBottom: "80px" }}>
        {/* Ako NEMAMO specijalan content (znači na putanji smo "/"), prikaži tabove */}
        {!content ? (
          <>
            <div className="home-navigation">
              <button
                className={activeTab === "live" ? "active" : ""}
                onClick={() => setActiveTab("live")}
              >
                Uživo
              </button>
              <button
                className={activeTab === "results" ? "active" : ""}
                onClick={() => setActiveTab("results")}
              >
                Rezultati
              </button>
              <button
                className={activeTab === "schedule" ? "active" : ""}
                onClick={() => setActiveTab("schedule")}
              >
                Raspored
              </button>
              <button
                className={activeTab === "groups" ? "active" : ""}
                onClick={() => setActiveTab("groups")}
              >
                Grupe
              </button>
            </div>
            <div className="home-content">{renderHomeContent()}</div>
          </>
        ) : (
          <div className="home-content">{content}</div>
        )}
        <HomeSponsors />
        {/*      <HomeNews /> */}
        <HomeFooter />
      </main>

      <BottomNavigation />
    </>
  );
};

export default HomePage;
